import { createCnaeListStore } from '@/stores/factories/cnaeListStoreFactory';
import accountAdminApi from '@/api/modules/accountAdmin';

export const useAccountCnaeListStore = createCnaeListStore('accountCnaeList', accountAdminApi);